export const selectPreset = {
  select: {
    root: {
      borderColor: 'var(--neutral--30)',
      hoverBorderColor: 'var(--neutral--40)',
      focusBorderColor: 'var(--brand--50)',
      focusRing: {
        width: '3px',
        color: 'rgba(21, 93, 252, 0.12)',
        offset: '0rem',
        style: 'solid',
      },
      invalidBorderColor: '#dc2626',
      disabledBackground: 'var(--neutral--10)',
      disabledColor: 'var(--neutral--50)',
    },
    option: {
      color: 'var(--neutral--70)',
      selectedBackground: 'var(--neutral--10)',
      selectedColor: 'var(--neutral--80)',
      selectedFocusBackground: 'var(--neutral--10)',
      selectedFocusColor: 'var(--neutral--80)',
    },
  },
};
